import { render, staticRenderFns } from "./RecaptchaV3.vue?vue&type=template&id=4a489758&"
import script from "./RecaptchaV3.vue?vue&type=script&lang=ts&"
export * from "./RecaptchaV3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports